import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog } from "@vixio/ui";

const mac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);

const LIST: Array<[string[], string]> = [
  [[mac ? "⌘" : "Ctrl", "K"], "Ir para qualquer tela, pessoa ou organização"],
  [["/"], "Buscar na lista da tela"],
  [["g", "i"], "Ir para o Início"],
  [["g", "p"], "Ir para Meu perfil e 2FA"],
  [["?"], "Mostrar estes atalhos"],
  [["Esc"], "Fechar janela, menu ou busca"],
];

/** Digitando num campo (ou editor) os atalhos de uma tecla ficam desligados. */
function typing(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null;
  if (!el) return false;
  return el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName);
}

/**
 * Atalhos de teclado do painel (além do Ctrl/⌘ K, que fica no Layout): "?" abre a lista, "/" vai para a busca da
 * tabela da tela e "g" seguido de outra tecla navega.
 */
export function Shortcuts() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const pendingG = useRef(0);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey || typing(e.target)) return;
      if (document.querySelector('[role="dialog"]')) return;
      if (e.key === "?") {
        e.preventDefault();
        setOpen(true);
        return;
      }
      if (e.key === "/") {
        const search = document.querySelector<HTMLInputElement>(
          '#conteudo .vx-table-toolbar__search input, #conteudo input[type="search"]',
        );
        if (search) {
          e.preventDefault();
          search.focus();
          search.select();
        }
        return;
      }
      if (e.key === "g") {
        pendingG.current = Date.now();
        return;
      }
      if (Date.now() - pendingG.current < 1200) {
        pendingG.current = 0;
        if (e.key === "i") navigate("/");
        else if (e.key === "p") navigate("/perfil");
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);

  return (
    <Dialog open={open} onOpenChange={setOpen} title="Atalhos do teclado" description="Funcionam fora dos campos de texto.">
      <dl className="os-keys">
        {LIST.map(([keys, label]) => (
          <div key={label} className="os-keys__row">
            <dt>
              {keys.map((k, i) => (
                <span key={k}>
                  {i > 0 ? <span className="muted"> {keys[0] === "g" ? "depois" : "+"} </span> : null}
                  <kbd className="vx-kbd">{k}</kbd>
                </span>
              ))}
            </dt>
            <dd>{label}</dd>
          </div>
        ))}
      </dl>
    </Dialog>
  );
}
